import { mergePathConfig } from 'src/navigation/linking/utils';
import { getQueryString } from '../10-app/deep-links/utils';
export const getEPQuestionDetailsLink = (questionID, otherParams = {}) => {
    return `exam-prep/question/${questionID}?${getQueryString(otherParams)}`;
};
export const examPreparationStackLinking = {
    screens: {
        EP_Subject: {
            path: 'exam-prep/subject/:subjectID',
            ...mergePathConfig(['examLevel', 'subject', 'filters'], ['tabID', 'offset', 'limit']),
        },
        EP_QP: {
            path: 'exam-prep/qp/:qpID',
            ...mergePathConfig(['examLevel', 'subject', 'qp'], ['offset', 'limit']),
        },
        EP_Question: {
            path: 'exam-prep/question/:questionID',
            ...mergePathConfig(['examLevel', 'subject', 'question', 'qp', 'navigationData', 'navigatedFrom'], ['tabID']),
        },
        EP_TopicQuestions: {
            path: 'exam-prep/topic-questions/:ancestorID/:topic',
            ...mergePathConfig(['examLevel', 'subject'], ['offset', 'limit']),
        },
        EP_AnswerHistory: {
            path: 'exam-prep/answer-history/:questionID',
        },
        EP_QuestionSearch: {
            path: 'exam-prep/question-search',
            ...mergePathConfig([], ['q', 'offset', 'limit']),
        },
        EP_NoteViewer: {
            path: 'exam-prep/note/:noteID',
        },
        EP_NoteEditor: {
            path: 'exam-prep/note-editor/:noteID',
            ...mergePathConfig([], ['tabID']),
        },
    },
};
export const examPreparationTabsLinking = {
    screens: {
        EP_Home: {
            path: 'exam-prep/*',
            ...mergePathConfig([], ['tabID', 'examLevelID']),
        },
    },
};
